import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RfiList from './List';
import RfiCreate from './Create';
import RfiDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    ResponseRequiredDate: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyComment: { visible: false, label: '', required: false },
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Details = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };
    if (workflowItem.replyEnabled) {
        fields.ResponseRequiredDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.RESPONSE_REQUIRED"], required: false };
    }

    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    // const workflowItem = workflowsQA[wfid];
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}


class RfiRouter extends React.Component {
    constructor(props) {
        super(props);

        this.notificationType = props.workflowItem.config.currentModelType;

        if (props.mode === 'SUPPLIER') {
            this.documentType = 'DocumentRFI';
        }
        else if (props.mode === 'PM') {
            this.documentType = 'DocumentRFIPM';
        }
        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;


        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<RfiList
                        {...this.props}

                        notificationType={this.notificationType}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <RfiCreate
                                {...this.props}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<RfiDetail
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}

                        notificationType={this.notificationType}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};



export default (RfiRouter);